import { useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

type SidebarType = {
  id: string
  title: string
  subtitle?: string
}

const useLayout = () => {
  const history = useHistory()
  const observersRef = useRef<IntersectionObserver[]>([])

  const [activeSection, setActiveSection] = useState<string>('detail-dasar')
  const [sidebarMenu, setSidebarMenu] = useState<SidebarType[]>([])

  const handleGoBack = () => {
    history.goBack()
  }

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  }

  return {
    activeSection,
    observersRef,
    sidebarMenu,
    setActiveSection,
    setSidebarMenu,
    scrollToSection,
    handleGoBack,
  }
}

export default useLayout
